import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userCount: 0,
  sessionData: {}, // 세션 데이터(진행자)
  participantData: {}, // 참가자 데이터(진행자 + 참가자)
  stepData: [], // 단계 데이터
  contentData: [], // 컨텐츠 데이터
  participants: [], // 참가자 목록
  qrModal: false, // QR 모달
  pageNumber: 0, // 페이지 번호
  videoPlaying: false, // 영상 교육 재생 여부
  videoPlayedFraction: 0, // 참가자 동기화: 진행자 재생 위치 비율(0~1), 웹소켓으로 수신
  meetFlag: false, // 안전보건회의 여부
  stepTransition: { isTransitioning: false, direction: 'next' }, // 단계 이동 오버레이 상태
};

const TbmSlice = createSlice({
  name: 'tbm',
  initialState,
  reducers: {
    setUserCount(state, action) {
      state.userCount = action.payload || 0;
    },
    setSessionData(state, action) {
      state.sessionData = action.payload || {};
    },
    setParticipantData(state, action) {
      state.participantData = action.payload || {};
    },
    setStepData(state, action) {
      state.stepData = action.payload || [];
    },
    setContentData(state, action) {
      state.contentData = action.payload || [];
    },
    setParticipants(state, action) {
      state.participants = Array.isArray(action.payload) ? action.payload : [];
    },
    setQrModal(state, action) {
      state.qrModal = Boolean(action.payload);
    },
    setPageNumber(state, action) {
      state.pageNumber = action.payload || 0;
    },
    setVideoPlaying(state, action) {
      state.videoPlaying = Boolean(action.payload);
    },
    setVideoPlayedFraction(state, action) {
      state.videoPlayedFraction = action.payload || 0;
    },
    setMeetFlag(state, action) {
      state.meetFlag = Boolean(action.payload);
    },
    setStepTransition(state, action) {
      state.stepTransition = {
        isTransitioning: Boolean(action.payload?.isTransitioning),
        direction: action.payload?.direction ?? 'next',
      };
    },
    resetTbm(state) {
      state.userCount = 0;
      state.sessionData = {};
      state.participantData = {};
      state.stepData = [];
      state.contentData = [];
      state.participants = [];
      state.qrModal = false;
      state.pageNumber = 0;
      state.videoPlaying = false;
      state.videoPlayedFraction = 0;
      state.meetFlag = false;
      state.stepTransition = { isTransitioning: false, direction: 'next' };
    },
  },
});

export const TbmActions = TbmSlice.actions;
export default TbmSlice.reducer;
